const buildFormParams = (vehicleDetails: Cinch.RecommendationsItem) => {
  const { make, model, bodyType, fuelType } = vehicleDetails

  return {
    fromPrice: -1,
    toPrice: -1,
    fromYear: -1,
    toYear: -1,
    mileage: -1,
    fromEngineSize: -1,
    toEngineSize: -1,
    sortingCriteria: 1,
    pageSize: 24,
    longitude: '',
    latitude: '',
    distance: 0,
    pageNumber: 1,
    make,
    query: '',
    selectedModel: model,
    bodyType: bodyType.toLowerCase(),
    fuelType: fuelType.toLowerCase(),
  }
}

export default buildFormParams
